import { z } from "zod";

import { apiGet, apiPost } from "../lib/api";
import { EngagementDetailResponseSchema } from "./engagements";

export const VideoRenderResponseSchema = z.object({
  video_id: z.string(),
  status: z.string(),
  error: z.string().nullable().default(null),
});
export type VideoRenderResponse = z.infer<typeof VideoRenderResponseSchema>;

export const VideoDispatchResponseSchema = z.object({
  bot_id: z.string(),
});
export type VideoDispatchResponse = z.infer<typeof VideoDispatchResponseSchema>;

export const VideoClipUrlResponseSchema = z.object({
  url: z.string(),
  expires_in: z.number(),
});
export type VideoClipUrlResponse = z.infer<typeof VideoClipUrlResponseSchema>;

// Recall's bot-status payload shape is provider-defined; accept anything.
export const VideoBotStatusSchema = z.record(z.unknown());

/** Stamp the hash over the current server-side script (3a). Returns the record. */
export function approveScript(engagementId: string) {
  return apiPost(`/api/engagements/${engagementId}/approve-script`, EngagementDetailResponseSchema);
}

/** Submit a render of the approved script (3c). */
export function submitRender(engagementId: string) {
  return apiPost(`/api/engagements/${engagementId}/video-render`, VideoRenderResponseSchema);
}

/** Poll render status; the GET stores the clip + stamps the record on completion. */
export function fetchRenderStatus(engagementId: string) {
  return apiGet(`/api/engagements/${engagementId}/video-render`, VideoRenderResponseSchema);
}

/** Mint a short-lived presigned URL to preview the bound clip (operator-only). */
export function fetchRenderClipUrl(engagementId: string) {
  return apiGet(
    `/api/engagements/${engagementId}/video-render/clip-url`,
    VideoClipUrlResponseSchema,
  );
}

/** Drop the Recall bot into the meeting to play the bound clip (3c). */
export function dispatchVideo(engagementId: string, meetingUrl: string) {
  return apiPost(`/api/engagements/${engagementId}/video-dispatch`, VideoDispatchResponseSchema, {
    meeting_url: meetingUrl,
  });
}

/** Poll the bot status; updates the dispatch snapshot server-side. */
export function fetchDispatchStatus(engagementId: string) {
  return apiGet(`/api/engagements/${engagementId}/video-dispatch`, VideoBotStatusSchema);
}

/** Leave the call. Returns the updated record. */
export function leaveDispatch(engagementId: string) {
  return apiPost(`/api/engagements/${engagementId}/video-dispatch/leave`, EngagementDetailResponseSchema);
}
